
  // -------- Toggle List (FAQs) ----------------- //

  jQuery('.toggle-header').click(function () { // Enable the toggle view list for ul.toggle-view for toggle-able lists

    //ScrollTrigger.refresh();

    var container = jQuery(this).closest('.toggle-view');
    var text = jQuery(this).closest('.toggle-view').children('div.panel');

    //If the text (i.e. the panel div) is hidden, then open it up. Otherwise hide the open text.
    if (text.is(':hidden')) {
      text.slideDown('200');
      container.addClass('open');
    } else {
      text.slideUp('200');
      container.removeClass('open');
    }

    //ScrollTrigger.refresh();

  });

var stockLeft = getCookie('stockLeft');
if (stockLeft == "") {
  stockLeft = generateRandom();
  setCookie('stockLeft', stockLeft, 1);
}

setTimeout(function () {
  jQuery("body").find("#shopify-section-template--16730614563068__16922999881d1c6187").append('<a href="/#shopify-section-template--16730614563068__4bdbea76-eb62-4bae-9826-3ed8b17e7b7a" class="read_more banner-button button">Read More Reviews</a>');
}, 1500);



jQuery(document).ready(function () {
  setInterval(function () {
    console.log('mobile devices working?');
    /***dropdown meu classes change******/
    // if(!jQuery("body").find(".menu-dropdown").hasClass('menu-dropdown-added')){
    jQuery("body").find(".menu-dropdown").find(".card-information__wrapper").addClass('card-information__wrapper-menu');
    jQuery("body").find(".menu-dropdown").find(".price-item").addClass('price-item-menu');
    jQuery("body").find(".menu-dropdown").find(".card").addClass('card-menu');
    jQuery("body").find(".menu-dropdown").find(".card-price").addClass('card-price-menu');
    jQuery("body").find(".menu-dropdown").find(".card-title-ellipsis").addClass('card-title-ellipsis-menu');
    jQuery("body").find(".menu-dropdown").find(".product").addClass('product-menu');
    jQuery("body").find(".menu-dropdown").find(".products-grid").addClass('products-grid-menu');
    jQuery("body").find(".menu-dropdown").find(".product-menu").addClass('product-menu-menu');
    jQuery("body").find(".menu-dropdown").find(".card-information").addClass('card-information-menu');
    jQuery("body").find(".menu-dropdown").find(".slick-dots").addClass('slick-dots-menu');
    jQuery("body").find(".menu-dropdown").find(".slick-slide").addClass('slick-slide-menu');
    jQuery("body").find(".menu-dropdown").find(".slick-track").addClass('slick-track-menu');
    jQuery("body").find(".menu-dropdown").addClass('menu-dropdown-added');
    // }

    jQuery(".slick-slide-menu").each(function () {
      // if(!jQuery(this).hasClass('width-added')){
      var width = $(window).width();
      // console.log('devices size ',0);
      if (width > 1024) {
        // console.log('devices size ',width);
        width = parseFloat(parseFloat(width - 50) / 3);
        var w = jQuery(this).width();
        jQuery(this).attr('style', 'width:' + width + 'px');
        // jQuery(this).attr('style','width:'+parseFloat(w-parseFloat(10))+'px');
        jQuery(this).addClass('width-added');
        // console.log('slide wwww ', jQuery(this).width());
      }

      // }
    })
  }, 5000);

});


jQuery("body").find(".productView-form").find(".productView-group").prepend('<h6 id="stock-left" class="stock-left">Hurry up! Only ' + stockLeft + ' bags left in stock. </h6>');
jQuery("body").find(".custom_box").find(".button").addClass("banner-button")
setInterval(function () {
  jQuery(".sls-purchase-options-container").find(".sls-option-container").find('.check').remove();
}, 100);
function generateRandom(min = 6, max = 20) {
  // find diff
  let difference = max - min;
  // generate random number 
  let rand = Math.random();
  // multiply with difference 
  rand = Math.floor(rand * difference);
  // add with min value 
  rand = rand + min;
  return rand;
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

console.log('random number : ', generateRandom());